import { MD5 } from 'crypto-js';
import qs from 'qs';
import http from './http';

export default {
  login: (username, password, resolve, reject) => {
    http
      .post(`rest/rpc/login`, {
        code: username,
        password: MD5(password).toString()
      })
      .then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(error);
        }
      )
      .catch(error => {
        reject(error);
      });
  },
  resetPassword: (username, identity, resolve, reject) => {
    http
      .put(
        `users/password`,
        qs.stringify({
          username: username,
          identity: identity
        })
      )
      .then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(error);
        }
      )
      .catch(error => {
        reject(error);
      });
  },
  updatePassword: (password, resolve, reject) => {
    http
      .post(
        `rest/rpc/change_password`,
        qs.stringify({
          password: `${password.trim()}`
        })
      )
      .then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(error);
        }
      )
      .catch(error => {
        reject(error);
      });
  },
  getConfig: (resolve, reject) => {
    http
      .get(`rest/config?key=eq.system`)
      .then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(error);
        }
      )
      .catch(error => {
        reject(error);
      });
  },
  getSemesters: (resolve, reject) => {
    http
      .get(`rest/semesters`)
      .then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(error);
        }
      )
      .catch(error => {
        reject(error);
      });
  },
  getOrgs: ({ semester_id, course_id, project_id }, resolve, reject) => {
    let url = `rest/course2orgs?select=*,orgs!inner(*,dicts:dicts!organization_type_fkey(*))&orgs.type=in.(class,reelectclass)&orgs.semester_id=eq.${semester_id}&orgs.path=cd.root.1&course_id=eq.${course_id}`;

    if (project_id) {
      url = `rest/course2orgs?select=*,orgs!inner(*, user_orgs(*, users:users_ex!user_organization_user_id_fkey!inner(*,user2projects:user2projects_ex!user2project_student_id_fkey!inner(*,projects:projects!user2project_project_id_fkey(*),schedules:schedules!user2project_schedule_id_fkey(*,periods(*)),reports(*,users(*),dicts(*))))))&orgs.type=in.(class,reelectclass)&orgs.semester_id=eq.${semester_id}&orgs.path=cd.root.1&course_id=eq.${course_id}&orgs.user_orgs.users.role=eq.student&orgs.user_orgs.users.user2projects.project_id=eq.${project_id}&orgs.user_orgs.users.user2projects.schedule_status=in.(elected,free_schedule)&orgs.user_orgs.users.semester_id=eq.${semester_id}`;
    }

    http
      .get(url)
      .then(
        res => {
          resolve(res.data);
        },
        err => {
          reject(err);
        }
      )
      .catch(err => {
        reject(err);
      });
  },
  getLessonElectives: (lesson, resolve, reject) => {
    http
      // .get(`lessons/${lesson}/electives`)
      .get(
        `rest/user2projects?select=*,users:users!user2project_student_id_fkey(*),projects!user2project_project_id_fkey(*),schedules(*,periods(*)),reports(*,users(*)),project_score&schedule_id=eq.${lesson}&schedule_status=eq.elected`
      )
      .then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(error);
        }
      )
      .catch(error => {
        reject(error);
      });
  },
  // 学生获取实验场次
  getLessons: (
    org,
    course,
    experiment,
    address,
    semester,
    teacher,
    start,
    end,
    resolve,
    reject
  ) => {
    let query = '';
    if (start) {
      query += `&date=gte.${start}`;
    }
    if (end) {
      query += `&date=lte.${end}`;
    }
    if (course) {
      query += `&course_id=eq.${course}`;
    }
    if (experiment) {
      query += `&project_id=eq.${experiment}`;
    }
    if (address) {
      query += `&location_id=eq.${address}`;
    }
    if (semester) {
      query += `&semester_id=eq.${semester}`;
    }
    if (teacher) {
      query += `&teacher_id=eq.${teacher}`;
    }
    http
      .get(
        `rest/check_schedules?select=*,projects:projects!schedule_project_id_fkey(*),periods(*),teachers:users!schedule_teacher_id_fkey(*)&is_publish=eq.true&organization_id=eq.${org}${query}`
      )
      .then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(error);
        }
      )
      .catch(error => {
        reject(error);
      });
  },
  getReports: (id, status, resolve, reject) => {
    // 扫描版报告
    let endponint = `report-api/reports/${id}/url`;
    // 微信上传的报告
    if (
      status === 'C' ||
      status === 'S' ||
      status === 'Draft' ||
      status === 'Re'
    ) {
      endponint = `report-api/reports/${id}/url?type=submit`;
    }
    http
      .get(endponint)
      .then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(error);
        }
      )
      .catch(error => {
        reject(error);
      });
  },
  getCheckReports: (id, resolve, reject) => {
    http
      .get(`report-api/reports/${id}/url?type=check`)
      .then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(error);
        }
      )
      .catch(error => {
        reject(error);
      });
  },
  // 修改批阅状态
  updateReportStatus: (reports, status, resolve, reject) => {
    http
      .patch(`rest/reports?user2project_id=in.(${reports})`, {
        status: status
      })
      .then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(error);
        }
      )
      .catch(error => {
        reject(error);
      });
  },
  // 上传报告
  updateReport: (report, resolve, reject) => {
    let formdata = new FormData();
    formdata.append('grade', report.grade);
    formdata.append('page', report.page);
    formdata.append('uid', report.student);
    formdata.append('rpt_status', report.status);
    formdata.append('rpt_commit_teacher', report.commitTeacher);
    report.files.forEach(url => {
      formdata.append('file', url);
    });
    http
      .post(`report-api/check/${report.id}`, formdata)
      .then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(error);
        }
      )
      .catch(error => {
        reject(error);
      });
  },
  // TODO: 拆分接口
  rotateReport: (report, resolve, reject) => {
    let formdata = new FormData();
    http
      .post(
        `report-api/check/${report.id}/rotate?countlist=${report.rotateTimes}`,
        formdata
      )
      .then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(error);
        }
      )
      .catch(error => {
        reject(error);
      });
  },
  getUsers: (role, department, resolve, reject) => {
    http
      .get(
        `rest/users?role=eq.${role}&user_orgs.orgs.id=eq.${department}&order=name`
      )
      .then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(error);
        }
      )
      .catch(error => {
        reject(error);
      });
  },
  getStudents: (org, codeOrName, resolve, reject) => {
    let url = `rest/users_ex?select=*,user2projects:user2projects_ex!user2project_student_id_fkey(*,projects:projects!user2project_project_id_fkey(*),schedules:schedules!user2project_schedule_id_fkey(*,periods(*)),reports(*,users(*),dicts(*)))&and=(or(code.like.*${codeOrName}*,name.like.*${codeOrName}*),role.eq.student)&org_type=eq.class&user2projects.schedule_status=in.(elected,free_schedule)&order=code`;

    if (org)
      url = `rest/users_ex?select=*,user2projects:user2projects_ex!user2project_student_id_fkey(*,projects:projects!user2project_project_id_fkey(*),schedules:schedules!user2project_schedule_id_fkey(*,periods(*)),reports(*,users(*),dicts(*)))&and=(org_id.eq.${org},or(code.like.*${codeOrName}*,name.like.*${codeOrName}*),role.eq.student)&org_type=eq.class&user2projects.schedule_status=in.(elected,free_schedule)&order=code`;

    http
      .get(url)
      .then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(error);
        }
      )
      .catch(error => {
        reject(error);
      });
  },
  getCurTeacher: (id, resolve, reject) => {
    http
      .get(`rest/users?id=eq.${id}`)
      .then(res => {
        resolve(res.data[0]);
      })
      .catch(error => {
        reject(error);
      });
  },
  getCourses: (org, semester, resolve, reject) => {
    http
      .get(
        `rest/courses?organization_id=eq.${org}&semester_id=eq.${semester}&order=name`
      )
      .then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(error);
        }
      )
      .catch(error => {
        reject(error);
      });
  },
  getExperiments: (org, semester, resolve, reject) => {
    http
      .get(
        `rest/projects?organization_id=eq.${org}&semester_id=eq.${semester}&order=name`
      )
      .then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(error);
        }
      )
      .catch(error => {
        reject(error);
      });
  },
  getCourseExperiments: (course_id, resolve, reject) => {
    http
      .get(
        `rest/course2projects?select=*,projects(id,code,name)&course_id=eq.${course_id}`
      )
      .then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(error);
        }
      )
      .catch(error => {
        reject(error);
      });
  },
  // 获取报告评分项类型
  getDeductionMarks: (resolve, reject) => {
    http
      .get(`rest/dicts?typecode=eq.004`)
      .then(
        res => resolve(res.data),
        err => reject(err)
      )
      .catch(err => reject(err));
  },
  // 获取报告评分项权限
  getDeductionStatus: (resolve, reject) => {
    http
      .get(`rest/dicts?typecode=eq.026`)
      .then(
        res => resolve(res.data),
        err => reject(err)
      )
      .catch(err => reject(err));
  },
  // 获取批阅扣分项
  getDeductionItems: (experiment, org, resolve, reject) => {
    http
      .get(
        `rest/report_check_items?select=*,dicts:dicts!report_check_item_dictionary_dictkey_fk(*),pub_status:pub_status!report_check_item_pub_status_fkey(*),users(*)&or=(project_code.in.(${experiment}),is_common.eq.true)&organization_id=eq.${org}&order=type_order,type,display_order,comment`
      )
      .then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(error);
        }
      )
      .catch(error => {
        reject(error);
      });
  },
  // 添加评分项
  addDeduction: (deduction, user, org, resolve, reject) => {
    http
      .post(`rest/report_check_items`, {
        user_id: user,
        organization_id: org,
        comment: deduction.description,
        hide_comment: deduction.hide_comment,
        scores: deduction.scores,
        hide_score: deduction.hide_score,
        project_code: deduction.isCommon ? null : deduction.experiment.code,
        is_common: deduction.isCommon,
        type: deduction.type === '' ? '其他' : deduction.type,
        type_order: deduction.type_order,
        check_mark: deduction.mark,
        pub_status: deduction.pub_status,
        tip: deduction.notes,
        display_order: deduction.order,
        color: deduction.color
      })
      .then(
        () => {
          resolve();
        },
        error => {
          reject(error);
        }
      )
      .catch(error => {
        reject(error);
      });
  },
  // 修改评分项
  updateDeduction: (deduction, resolve, reject) => {
    http
      .patch(`rest/report_check_items/${deduction.id}`, {
        comment: deduction.description,
        hide_comment: deduction.hide_comment,
        scores: deduction.scores,
        hide_score: deduction.hide_score,
        project_code: deduction.isCommon ? null : deduction.experiment,
        is_common: deduction.isCommon,
        type: deduction.type === '' ? '其他' : deduction.type,
        type_order: deduction.type_order,
        check_mark: deduction.mark,
        pub_status: deduction.pub_status,
        tip: deduction.notes,
        display_order: deduction.order,
        color: deduction.color
      })
      .then(
        () => {
          resolve();
        },
        error => {
          reject(error);
        }
      )
      .catch(error => {
        reject(error);
      });
  },
  // 提交评分项
  submitDeduction: (id, resolve, reject) => {
    http
      .patch(`rest/report_check_items/${id}`, { pub_status: 'preview' })
      .then(
        () => {
          resolve();
        },
        error => {
          reject(error);
        }
      )
      .catch(error => {
        reject(error);
      });
  },
  // 退回提交的评分项
  submitBackDeduction: (id, resolve, reject, notify) => {
    http
      .get(`rest/report_check_items/${id}`)
      .then(res => {
        // 撤回前检查是否已经被中心管理员通过，变成 public 状态
        if (res.data.pub_status === 'public') {
          notify();
          resolve();
        } else {
          http
            .patch(`rest/report_check_items/${id}`, { pub_status: 'private' })
            .then(
              () => {
                resolve();
              },
              error => {
                reject(error);
              }
            )
            .catch(error => {
              reject(error);
            });
        }
      })
      .catch(err => reject(err));
  },
  submitBackDeductionAdmin: (id, resolve, reject) => {
    http
      .get(`rest/report_check_items/${id}`)
      .then(res => {
        http
          .patch(`rest/report_check_items/${id}`, { pub_status: 'private' })
          .then(
            () => {
              resolve();
            },
            error => {
              reject(error);
            }
          )
          .catch(error => {
            reject(error);
          });
      })
      .catch(err => reject(err));
  },
  // 通过分享的评分项
  submitCheckedDeduction: (id, resolve, reject, notify) => {
    http
      .get(`rest/report_check_items/${id}`)
      .then(res => {
        // 通过前检查是否已经被教师退回，变成 private 状态
        if (res.data.pub_status === 'private') {
          notify();
          resolve();
        } else {
          http
            .patch(`rest/report_check_items/${id}`, { pub_status: 'public' })
            .then(
              () => {
                resolve();
              },
              error => {
                reject(error);
              }
            )
            .catch(error => {
              reject(error);
            });
        }
      })
      .catch(err => reject(err));
  },
  // 删除评分项
  deleteDeduction: (id, resolve, reject) => {
    http
      .delete(`rest/report_check_items/${id}`)
      .then(
        () => {
          resolve();
        },
        error => {
          reject(error);
        }
      )
      .catch(error => {
        reject(error);
      });
  },
  // 重改时获取批阅记录
  getDrawprocess: (id, resolve, reject) => {
    http
      .get(`/rest/report_check_stats?user2project_id=eq.${id}`)
      .then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(error);
        }
      )
      .catch(error => {
        // reject(error);
      });
  },
  // 更新批阅记录
  updateDeductionPoint: (student, payload, resolve, reject) => {
    http
      .post(
        `/rest/report_check_stats?on_conflict=user2project_id`,
        {
          user2project_id: student,
          layer_data: payload
        },
        {
          headers: {
            Prefer: 'resolution=merge-duplicates'
          }
        }
      )
      .then(
        () => {
          resolve();
        },
        error => {
          reject(error);
        }
      )
      .catch(error => {
        reject(error);
      });
  },
  getSendbackPoints: (resolve, reject) => {
    http
      .get(`rest/report_sendback_items`)
      .then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(error);
        }
      )
      .catch(error => {
        reject(error);
      });
  },
  addSendbackPoint: (expression, teacher, resolve, reject) => {
    http
      .post('rest/report_sendback_items', {
        comment: expression,
        user_id: teacher
      })
      .then(
        () => {
          resolve();
        },
        error => {
          reject(error);
        }
      )
      .catch(error => {
        reject(error);
      });
  },
  deleteSendbackPoints: (id, resolve, reject) => {
    http
      .delete(`rest/report_sendback_items/${id}`)
      .then(
        () => {
          resolve();
        },
        error => {
          reject(error);
        }
      )
      .catch(error => {
        reject(error);
      });
  },
  addSendback: (elective, checkedItems, show_check_stat, resolve, reject) => {
    http
      .post(
        `rest/report_sendback_stats?on_conflict=user2project_id`,
        {
          user2project_id: elective,
          comment: checkedItems,
          show_check_stat
        },
        {
          headers: {
            Prefer: 'resolution=merge-duplicates'
          }
        }
        // checkedItems.map(x=> {
        //   return {
        //     user2project_id: elective,
        //     comment: x
        //   }
        // })
      )
      .then(
        () => {
          resolve();
        },
        error => {
          reject(error);
        }
      )
      .catch(error => {
        reject(error);
      });
  },
  addNotification: (title, user_id, data, centre_id) => {
    http.post(`rest/notifications`, {
      title: title,
      push2wechat: 'true',
      user_id_list: `{${user_id}}`,
      data: data,
      organization_id: centre_id,
      type: 'wechat_template',
      template_type: 'report_msg'
    });
  },
  getHistories: (teacher_id, limit, offset, resolve, reject) => {
    http
      .get(
        `rest/report_check_stats?select=*,user2projects!inner(*,reports!inner(*),check_schedules(*,projects:projects!schedule_project_id_fkey(*),periods(*),teachers:users!schedule_teacher_id_fkey(*)),users:users!user2project_student_id_fkey(*),projects!user2project_project_id_fkey(*),schedules(*,periods(*)),reports(*,users(*)),project_score)&user2projects.reports.teacher_id=eq.${teacher_id}&order=updated_at.desc&limit=${limit}&offset=${offset}`
      )
      .then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(error);
        }
      )
      .catch(error => {
        reject(error);
      });
  }
};
